import { render, staticRenderFns } from "./ModalProductAdded.vue?vue&type=template&id=57a0fe46&"
import script from "./ModalProductAdded.vue?vue&type=script&lang=js&"
export * from "./ModalProductAdded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports